// Logos oficiales (archivos del manual, nunca retipeados). Servidos desde public/brand/
// (copias de docs/marca/logos/svg/). Módulo aparte de brand.tsx para que la app
// logueada pueda usarlos sin arrastrar brand.css del sitio público.
export const LOGO_VERDE = '/brand/logo-horizontal-verde.svg';
export const LOGO_BLANCO = '/brand/logo-horizontal-blanco.svg';
export const ISOTIPO_VERDE = '/brand/isotipo-verde.svg';
export const ISOTIPO_BLANCO = '/brand/isotipo-blanco.svg';
